export class AppUserClaim  {
    permissionId: string = "";
    userId: string = "";
    permissionControl: string = "";
    permissionName: string = "";
    permissionValue: string = "";
    permissionTypeName: string = "";
}
  